import { Box, Flex } from 'theme-ui';
import LoginContainer from '../../components/Login/LoginContainer';
import useWindowSize from '../../utils/useWindowSize';
import Login from '../../asset/images/login.svg';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backgroundImage from '../../asset/icons/BG.svg';
import { getwindowSizes } from '../../utils/utilityFunction';

const LoginLayout = () => {
  const { height } = useWindowSize();

  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
  if (isLoggedIn) navigate('/');
  const { width } = useWindowSize();

  return (
    <Box
      sx={{
        width: '100%',
        height: height
      }}
    >
      <Flex
        sx={{
          position: 'relative',
          width: '100%',
          height: height,
          justifyContent: 'center'
        }}
      >
        <Flex
          className='login-left-container'
          sx={{
            position: 'relative',
            width: '50%',
            height: height,
            margin: 'auto',
            justifyContent: 'center',
            alignItems: 'center',
            background:
              'linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), linear-gradient(302deg, #1A65D6 -2.4%, #5095FC 29.71%, #A0C4F8 98.5%)'
          }}
        >
          <img
            src={Login}
            alt='login-svg'
            style={{
              width: '100%',
              height: '100%'
            }}
          />
        </Flex>
        <Flex
          sx={
            width >= getwindowSizes.s_tempdesktop &&
            width <= getwindowSizes.l_tablet
              ? {
                  position: 'relative',
                  width: '50%',
                  height: height,
                  justifyContent: 'center',
                  alignItems: 'center',
                  background:
                    'linear-gradient(180deg, #FFF 0%, #DCEBFF 105.92%)',
                  backgroundImage: `url(${backgroundImage})`,
                  backgroundSize: 'cover',
                  backgroundRepeat: 'no-repeat',
                  backgroundPosition: 'bottom'
                }
              : {
                  position: 'relative',
                  width: '50%',
                  height: height,
                  justifyContent: 'center',
                  alignItems: 'center',
                  background:
                    'linear-gradient(180deg, #FFF 0%, #DCEBFF 105.92%)'
                }
          }
          className='login-container-right'
        >
          <LoginContainer />
        </Flex>
      </Flex>
    </Box>
  );
};

export default LoginLayout;
